<div class="main-card">
  <div class="main-card-container">
    <div class="icon-container" [ngClass]="mainColor">
      <img height="48" width="48" [ngSrc]="'assets/img/module-icon/' + icon + '.svg'" alt="">
    </div>
    <h2 class="title" [class.has-button]="!!buttonLink">{{title | translate}}</h2>
    <div *ngIf="!!badge" class="badge-container">
      <span class="badge">{{ badge | translate }}</span>
    </div>
    <button *ngIf="!!buttonLink" class="btn btn-md btn-white reverse" type="button" aria-label="Know more">
      <a [routerLink]="buttonLink" class="link"></a>
      {{'MAIN.LEARN_MORE' | translate}}
      <img ngSrc="assets/img/arrow-small-right.svg" height="24" width="24" alt="">
    </button>
    <div class="img-container">
      <picture>
        <source media="(max-width: 799px)" [srcset]="imgMob" type="image/webp">
        <source media="(min-width: 800px)" [srcset]="img" type="image/webp">
<!--        <img *ngIf="!priorityImg"  [src]="imgMob" height="580" [alt]="imgAlt" loading="lazy">-->
        <img *ngIf="!priorityImg"  [src]="imgMob" height="580" [alt]="imgAlt">
        <img *ngIf="priorityImg"  [src]="imgMob" height="580" [alt]="imgAlt" priority>
      </picture>
    </div>


  </div>
</div>
